export function ActionItemsCountView({
  className = '',
  ...props
}: {
  className?: string
  children: React.ReactNode
}) {
  return (
    <span
      {...props}
      className={`tw-inline-flex tw-items-center tw-justify-center tw-font-semibold tw-px-2 tw-bg-sunshine-500 tw-text-black-faded tw-rounded-full ${className}`}
    />
  )
}
